import { Injectable } from '@angular/core';

@Injectable()
export class MarkdownService {
  private parser: { renderInline: any };
  constructor() {
    this.parser = window.markdownit({
      linkify: true,
      typographer: true,
      html: true,
    });
  }

  public renderInline(html: string) {
    return this.parser.renderInline(html);
  }
}
